import { render, staticRenderFns } from "./RechargePrice.vue?vue&type=template&id=1a5a17c6&"
import script from "./RechargePrice.vue?vue&type=script&lang=js&"
export * from "./RechargePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports